import { inject, Service } from '@angular/core';
import { ServicesService } from '../services/services.service';

@Service()
export class GroupEndpointsService {
  readonly #service = inject(ServicesService);

  public endpoint() {
    return this.#service.groupServices('').replace(/\/$/, '');
  }

  public groups() {
    return this.#service.groupServices(`groups`);
  }

  public group(id: string) {
    return this.#service.groupServices(`groups/${id}`);
  }

  public guiAsset(asset: string) {
    return this.#service.groupServices(`gui/v2/${asset}`);
  }

  public manifest() {
    return this.guiAsset('manifest.json');
  }

  public users() {
    return this.#service.groupServices('users');
  }

  public currentUser() {
    return this.#service.groupServices('users/current');
  }

  public subscribe(userId: string) {
    return this.#service.groupServices(`groups/subscriptions/${userId}`);
  }

  public demo(sourceGroupId: string, code: string) {
    return this.#service.groupServices(`groups/${sourceGroupId}/demo/${code}`);
  }

  public cloneDemoData(groupId: string) {
    return this.#service.thorEndpoint(
      `group/${groupId}/clone-data-for-demogroup`,
    );
  }
}
